import React, { useState } from 'react';
import api from '../services/api';


const TokenAllocationForm = ({ user, onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    amount: '',
    expiryDate: '',
    reason: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await api.post('/admin/users/tokens/allocate', {
        userId: user._id,
        amount: parseInt(formData.amount),
        expiryDate: formData.expiryDate,
        reason: formData.reason
      });

      onSuccess(response.data);
    } catch (err) {
      console.error('Token allocation error:', err.response?.data);
      setError(err.response?.data?.message || 'Failed to allocate tokens');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Number of Tokens
        </label>
        <input
          type="number"
          name="amount"
          min="1"
          required
          value={formData.amount}
          onChange={handleChange}
          className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-orange-500 focus:ring-orange-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Expiry Date
        </label>
        <input
          type="date"
          name="expiryDate"
          value={formData.expiryDate}
          onChange={handleChange}
          min={new Date().toISOString().split('T')[0]}
          className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-orange-500 focus:ring-orange-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Reason
        </label>
        <textarea
          name="reason"
          value={formData.reason}
          onChange={handleChange}
          className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-orange-500 focus:ring-orange-500"
          rows="3"
        />
      </div>

      {error && (
        <div className="text-sm text-red-600">{error}</div>
      )}

      <div className="flex justify-end space-x-3">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          disabled={loading}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-sm font-medium text-white bg-orange-600 rounded-md hover:bg-orange-700 disabled:opacity-50"
          disabled={loading}
        >
          {loading ? 'Allocating...' : 'Allocate Tokens'}
        </button>
      </div>
    </form>
  );
};

export default TokenAllocationForm;